import React from "react";
import { Box } from "@mui/material";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import ActionButton from "../ActionButton";
import NoticeBanner from "../NoticeBanner";
import { useIsDesktop } from "../hooks/useIsDesktop";
import {
  SEND_COLOR,
  SEND_COLOR_DARK,
} from "../../../constants/colors";

export default function RequestGuidePanel({
  onClick,
}) {

  // レスポンシブ
  const isDesktop = useIsDesktop();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isDesktop ? "row" : "column",
        gap: 1,
        width: isDesktop ? "auto" : "100%",
        alignItems: "center",
      }}
    >
      <NoticeBanner
        text={"希望条件を入力してください"}
      />
      <ActionButton
        onClick={onClick}
        label={"希望条件を入力"}
        icon={<ModeEditOutlinedIcon sx={{ color: SEND_COLOR }} />}
        sx={{
          bgcolor: SEND_COLOR,
          width: isDesktop ? "auto" : "100%",
          "&:hover": { bgcolor: SEND_COLOR_DARK },
        }}
      />
    </Box>
  );
}